import { AssignedWorkflow, WorkflowStatus } from '../models/Workflows';
import { QTask, QTaskTag, TaskStatus, TaskPriority } from '@qwealth/qdata';

const createTaskTag = (key: string): QTaskTag => ({
  partnerId: 99,
  key,
});

const createTask = (
  id: number,
  title: string,
  details: string,
  status: TaskStatus,
  priority: TaskPriority,
  dueDate: string | null,
  taskTags: QTaskTag[],
  workflowId: string,
  workflowName: string,
  workflowGroup: number,
  workflowTags: QTaskTag[],
): QTask => ({
  id,
  assignee: 'janine@qwealth.com',
  householdQID: 'QW-QW-2-001012',
  dueDate,
  title,
  details,
  isInternal: 0,
  partnerID: 99,
  status,
  priority,
  householdName: 'Test, Janine',
  householdType: 'Regular',
  householdIaCode: 'QWMP',
  taskTags,
  lastUpdatedBy: 'janine@qwealth.com',
  createdBy: 'janine@qwealth.com',
  lastUpdated: '2025-12-15T10:00:00Z',
  startTime: '2025-12-01T09:00:00Z',
  // workflowId,
  // workflowName,
  // workflowGroup,
  // workflowTags,
  taskType: 'Standard',
});

export const mockAssignedWorkflows: AssignedWorkflow[] = [
  // Workflow 1: Simple - 1 group, 1 task
  {
    uuid: 'workflow-001',
    householdQID: 'QW-QW-2-001012',
    householdName: 'Test, Janine',
    householdType: 'Regular',
    name: 'Client Onboarding',
    taskTags: [createTaskTag('action'), createTaskTag('Bla2')],
    description:
      'What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    currentDueDate: '2025-12-20',
    status: 'In Progress' as WorkflowStatus,
    workflowRepr: [
      {
        tasksGroup: [
          createTask(
            1111,
            'Complete KYC Documentation',
            'Collect and verify all Know Your Customer documentation',
            'In Progress',
            'High',
            '2025-12-20',
            [],
            'workflow-001',
            'Client Onboarding',
            0,
            [createTaskTag('action'), createTaskTag('Bla2')],
          ),
        ],
      },
    ],
  },

  // Workflow 2: 2 groups with varying tasks
  {
    uuid: 'workflow-002',
    householdQID: 'QW-QW-2-001012',
    householdName: 'Test, Janine',
    householdType: 'Regular',
    name: 'Annual Review Process',
    taskTags: [createTaskTag('Cats'), createTaskTag('hammertime3')],
    description:
      'Where does it come from?Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.',
    currentDueDate: '2025-12-31',
    status: 'Not Started' as WorkflowStatus,
    workflowRepr: [
      {
        tasksGroup: [
          createTask(
            2222,
            'Gather Financial Statements',
            'Collect all financial statements from the past year',
            'Not Started',
            'High',
            '2025-12-22',
            [createTaskTag('Bla2')],
            'workflow-002',
            'Annual Review Process',
            0,
            [createTaskTag('Cats'), createTaskTag('hammertime3')],
          ),
          createTask(
            3333,
            'Review Investment Performance',
            'Analyze portfolio performance against benchmarks',
            'Not Started',
            'High',
            '2025-12-25',
            [createTaskTag('action')],
            'workflow-002',
            'Annual Review Process',
            0,
            [createTaskTag('Cats'), createTaskTag('hammertime3')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            4444,
            'Schedule Review Meeting',
            'Book meeting with client to discuss findings',
            'Not Started',
            'Medium',
            '2025-12-28',
            [createTaskTag('Bla2')],
            'workflow-002',
            'Annual Review Process',
            1,
            [createTaskTag('Cats'), createTaskTag('hammertime3')],
          ),
          createTask(
            5555,
            'Prepare Review Report',
            'Create comprehensive annual review report',
            'Not Started',
            'High',
            '2025-12-31',
            [],
            'workflow-002',
            'Annual Review Process',
            1,
            [createTaskTag('Cats'), createTaskTag('hammertime3')],
          ),
          createTask(
            6666,
            'Update Client Portal',
            'Upload all relevant documents to client portal',
            'Not Started',
            'Low',
            '2025-12-31',
            [],
            'workflow-002',
            'Annual Review Process',
            1,
            [createTaskTag('Cats'), createTaskTag('hammertime3')],
          ),
        ],
      },
    ],
  },

  // Workflow 3: 3 groups with multiple tasks
  {
    uuid: 'workflow-003',
    householdQID: 'QW-QW-2-001012',
    householdName: 'Test, Janine',
    householdType: 'Regular',
    name: 'Estate Planning Review',
    taskTags: [createTaskTag('joetag'), createTaskTag('action')],
    description: 'Complete estate planning documentation and review',
    currentDueDate: '2026-01-15',
    status: 'In Progress' as WorkflowStatus,
    workflowRepr: [
      {
        tasksGroup: [
          createTask(
            7,
            'Review Current Will',
            'Review existing will and identify updates needed',
            'Completed',
            'High',
            '2025-12-10',
            [createTaskTag('Bla2')],
            'workflow-003',
            'Estate Planning Review',
            0,
            [createTaskTag('joetag'), createTaskTag('action')],
          ),
          createTask(
            8,
            'Review Power of Attorney',
            'Verify POA documents are current and valid',
            'Completed',
            'High',
            '2025-12-12',
            [createTaskTag('Bla2')],
            'workflow-003',
            'Estate Planning Review',
            0,
            [createTaskTag('joetag'), createTaskTag('action')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            9,
            'Contact Estate Attorney',
            'Schedule meeting with estate planning attorney',
            'In Progress',
            'High',
            '2025-12-18',
            [createTaskTag('Bla2')],
            'workflow-003',
            'Estate Planning Review',
            1,
            [createTaskTag('joetag'), createTaskTag('action')],
          ),
          createTask(
            10,
            'Gather Asset Information',
            'Compile complete list of assets and beneficiaries',
            'In Progress',
            'Medium',
            '2025-12-20',
            [],
            'workflow-003',
            'Estate Planning Review',
            1,
            [createTaskTag('joetag'), createTaskTag('action')],
          ),
          createTask(
            11,
            'Review Trust Documents',
            'Review existing trust structures and documentation',
            'Not Started',
            'High',
            '2025-12-23',
            [],
            'workflow-003',
            'Estate Planning Review',
            1,
            [createTaskTag('joetag'), createTaskTag('action')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            12,
            'Draft Updated Documents',
            'Work with attorney to draft updated estate documents',
            'Not Started',
            'High',
            '2026-01-05',
            [],
            'workflow-003',
            'Estate Planning Review',
            2,
            [createTaskTag('joetag'), createTaskTag('action')],
          ),
          createTask(
            13,
            'Client Review Meeting',
            'Present updated documents to client for review',
            'Not Started',
            'Medium',
            '2026-01-10',
            [createTaskTag('Bla2')],
            'workflow-003',
            'Estate Planning Review',
            2,
            [createTaskTag('joetag'), createTaskTag('action')],
          ),
          createTask(
            14,
            'Execute Documents',
            'Finalize and execute all estate planning documents',
            'Not Started',
            'High',
            '2026-01-15',
            [createTaskTag('Bla2')],
            'workflow-003',
            'Estate Planning Review',
            2,
            [createTaskTag('joetag'), createTaskTag('action')],
          ),
        ],
      },
    ],
  },

  // Workflow 4: 4 groups with varying complexity
  {
    uuid: 'workflow-004',
    householdQID: 'QW-QW-2-001012',
    householdName: 'Test, Janine',
    householdType: 'Regular',
    name: 'Tax Planning Strategy',
    taskTags: [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
    description: 'Year-end tax planning and optimization',
    currentDueDate: null,
    status: 'Blocked' as WorkflowStatus,
    workflowRepr: [
      {
        tasksGroup: [
          createTask(
            15,
            'Obtain Tax Returns',
            'Collect prior year tax returns from client',
            'Blocked',
            'High',
            '2025-12-19',
            [],
            'workflow-004',
            'Tax Planning Strategy',
            0,
            [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            16,
            'Calculate Tax Projections',
            'Project current year tax liability',
            'Not Started',
            'High',
            '2025-12-22',
            [],
            'workflow-004',
            'Tax Planning Strategy',
            1,
            [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
          ),
          createTask(
            17,
            'Identify Tax-Loss Harvesting',
            'Review portfolio for tax-loss harvesting opportunities',
            'Not Started',
            'Medium',
            '2025-12-23',
            [],
            'workflow-004',
            'Tax Planning Strategy',
            1,
            [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            18,
            'Review Charitable Giving',
            'Analyze charitable giving strategies and opportunities',
            'Not Started',
            'Low',
            '2025-12-26',
            [],
            'workflow-004',
            'Tax Planning Strategy',
            2,
            [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
          ),
          createTask(
            19,
            'Evaluate Roth Conversions',
            'Assess Roth IRA conversion opportunities',
            'Not Started',
            'Medium',
            '2025-12-27',
            [],
            'workflow-004',
            'Tax Planning Strategy',
            2,
            [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
          ),
          createTask(
            20,
            'RMD Calculations',
            'Calculate required minimum distributions',
            'Not Started',
            'High',
            '2025-12-28',
            [],
            'workflow-004',
            'Tax Planning Strategy',
            2,
            [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            21,
            'Prepare Tax Strategy Summary',
            'Create comprehensive tax planning summary',
            'Not Started',
            'Medium',
            '2025-12-30',
            [],
            'workflow-004',
            'Tax Planning Strategy',
            3,
            [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
          ),
          createTask(
            22,
            'Client Tax Meeting',
            'Present tax strategies to client',
            'Not Started',
            'High',
            '2025-12-31',
            [],
            'workflow-004',
            'Tax Planning Strategy',
            3,
            [createTaskTag('Bla2'), createTaskTag('Cats'), createTaskTag('action')],
          ),
        ],
      },
    ],
  },

  // Workflow 5: 5 groups with maximum complexity
  {
    uuid: 'workflow-005',
    householdQID: 'QW-QW-2-001012',
    householdName: 'Test, Janine',
    householdType: 'Regular',
    name: 'Comprehensive Financial Plan Update',
    taskTags: [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
    description: 'Full financial planning review and update across all domains',
    currentDueDate: '2026-02-28',
    status: 'Not Started' as WorkflowStatus,
    workflowRepr: [
      {
        tasksGroup: [
          createTask(
            23,
            'Client Data Gathering',
            'Collect updated client information and documentation',
            'Not Started',
            'High',
            '2026-01-10',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            0,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            24,
            'Update Financial Profile',
            'Update client financial profile in system',
            'Not Started',
            'Medium',
            '2026-01-12',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            0,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            25,
            'Investment Analysis',
            'Comprehensive investment portfolio analysis',
            'Not Started',
            'High',
            '2026-01-17',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            1,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            26,
            'Risk Tolerance Assessment',
            'Re-evaluate client risk tolerance and investment objectives',
            'Not Started',
            'Medium',
            '2026-01-18',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            1,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            27,
            'Asset Allocation Review',
            'Review and recommend asset allocation adjustments',
            'Not Started',
            'High',
            '2026-01-20',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            1,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            28,
            'Insurance Coverage Review',
            'Review all insurance policies for adequacy',
            'Not Started',
            'Medium',
            '2026-01-24',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            2,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            29,
            'Life Insurance Needs Analysis',
            'Calculate current life insurance needs',
            'Not Started',
            'High',
            '2026-01-25',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            2,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            30,
            'Disability Coverage Assessment',
            'Evaluate disability insurance coverage',
            'Not Started',
            'Medium',
            '2026-01-26',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            2,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            31,
            'Long-term Care Review',
            'Assess long-term care insurance options',
            'Not Started',
            'Low',
            '2026-01-27',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            2,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            32,
            'Retirement Projection Update',
            'Update retirement cash flow projections',
            'Not Started',
            'High',
            '2026-02-05',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            3,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            33,
            'Social Security Analysis',
            'Analyze optimal Social Security claiming strategy',
            'Not Started',
            'Medium',
            '2026-02-07',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            3,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            34,
            'Pension Review',
            'Review pension options and payout strategies',
            'Not Started',
            'Medium',
            '2026-02-08',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            3,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            35,
            'Healthcare Cost Planning',
            'Project healthcare costs in retirement',
            'Not Started',
            'Low',
            '2026-02-10',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            3,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
        ],
      },
      {
        tasksGroup: [
          createTask(
            36,
            'Draft Financial Plan',
            'Prepare comprehensive financial plan document',
            'Not Started',
            'High',
            '2026-02-20',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            4,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            37,
            'Internal Plan Review',
            'Internal review of financial plan by senior advisor',
            'Not Started',
            'Medium',
            '2026-02-22',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            4,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            38,
            'Prepare Presentation',
            'Create client presentation materials',
            'Not Started',
            'Medium',
            '2026-02-24',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            4,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            39,
            'Schedule Plan Presentation',
            'Book meeting with client for plan presentation',
            'Not Started',
            'High',
            '2026-02-25',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            4,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
          createTask(
            40,
            'Present Financial Plan',
            'Deliver comprehensive financial plan to client',
            'Not Started',
            'High',
            '2026-02-28',
            [],
            'workflow-005',
            'Comprehensive Financial Plan Update',
            4,
            [createTaskTag('action'), createTaskTag('hammertime3'), createTaskTag('joetag')],
          ),
        ],
      },
    ],
  },
];
